// src/theme/theme.ts
import {
  createTheme,
  responsiveFontSizes,
  type Theme,
} from "@mui/material/styles";

export function createAppTheme(mode: "light" | "dark"): Theme {
  const isLight = mode === "light";

  const base = createTheme({
    palette: {
      mode,
      primary: {
        main: isLight ? "#7c3aed" : "#a78bfa",
        light: isLight ? "#a78bfa" : "#c4b5fd",
        dark: isLight ? "#5b21b6" : "#7c3aed",
        contrastText: isLight ? "#ffffff" : "#0f0b2e",
      },
      secondary: {
        main: isLight ? "#2563eb" : "#60a5fa",
      },
      background: {
        default: isLight ? "#faf8ff" : "#0c0826",
        paper: isLight ? "#ffffff" : "#0f0b2e",
      },
      text: {
        primary: isLight ? "#1e1b4b" : "#e2e8f0",
        secondary: isLight ? "#64748b" : "#94a3b8",
      },
      success: { main: isLight ? "#22c55e" : "#4ade80" },
      warning: { main: isLight ? "#f59e0b" : "#fbbf24" },
      error: { main: "#ef4444" },
      divider: isLight ? "#ede9fe" : "#2e1f6b",
    },
    typography: {
      fontFamily:
        '"Inter Variable", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: { fontWeight: 800 },
      h5: { fontWeight: 800 },
      h6: { fontWeight: 700 },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: `1px solid ${isLight ? "#ede9fe" : "#2e1f6b"}`,
            boxShadow: "none",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 12,
            "&:focus-visible": {
              outline: `2px solid ${isLight ? "#7c3aed" : "#a78bfa"}`,
              outlineOffset: 2,
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            [theme.breakpoints.down("md")]: {
              minWidth: 44,
              minHeight: 44,
            },
          }),
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: { borderRadius: 12 },
          input: ({ theme }) => ({
            [theme.breakpoints.down("md")]: {
              fontSize: 16,
            },
          }),
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 8 },
        },
      },
    },
  });
  return responsiveFontSizes(base);
}
